import type { IModule } from "angular";
import { module } from "angular";

import "App/Modules/Repositories";

export const app: IModule = module("mmServices", ["pascalprecht.translate", "irUtils", "mmRepositories"]);

app.run([
    "irPageService",
    () => {
        // empty block
    },
]);
